import React from "react";
import ActionRow from "../ActionRow";
import { formatujPercentoBezZnamienkaText, eur } from "../../utils/formatovanie";

export default function VypoctyKarta({
  suma,
  hodnotazabezpecenia,
  urok,
  fixacia,
  roky,
  splatka,
  stresssplatka,
  dtiVysledok,
  stressdti,
  dstistresssplatka,
  maFincloudTip,
  fincloudTip,
  fincloudTipPlaceholder,
resetujAplikaciu,
  ulozPonukuPdf,
}) {

  const maxVyskaUveru = Math.round(
    Math.min(
      Math.max(0, Number(dtiVysledok) || 0),
      Math.max(0, Number(stressdti) || 0)
    )
  );

  const jePrekrocenaMaxVyskaUveru =
    Number(suma) > 0 &&
    maxVyskaUveru > 0 &&
    Number(suma) > maxVyskaUveru;

  const jePrekrocenaMaxSplatkaDsti =
    Number(stresssplatka) > 0 &&
    Number(dstistresssplatka) > 0 &&
    Number(stresssplatka) > Number(dstistresssplatka);

  return (
    <div className="card-section">
                <h2>Výpočty</h2>
    
                <div className="pp-text">
                  <div className="pp-riadky">
                    <div className="pp-riadok">
                      <span className="pp-k">Výška úveru:</span>
                      <span className={`pp-v pp-v--normal ${jePrekrocenaMaxVyskaUveru ? 'pp-v--error' : ''}`}>
                        <strong>{eur(Math.max(0, Number(suma) || 0))} €</strong>
                      </span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">LTV:</span>
                      <span className="pp-v pp-v--normal">
                        {Number(suma) > 0 && Number(hodnotazabezpecenia) > 0
                          ? `${Math.round((Number(suma) / Number(hodnotazabezpecenia)) * 100)} %`
                          : '0 %'}
                      </span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">Úroková sadzba:</span>
                      <span className="pp-v pp-v--normal"><strong>{formatujPercentoBezZnamienkaText(urok)}</strong></span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">Fixácia:</span>
                      <span className="pp-v pp-v--normal">{Math.max(0, Number(fixacia) || 0)} r</span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">Splatnosť:</span>
                      <span className="pp-v pp-v--normal">{Math.max(0, Number(roky) || 0)} r</span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">Splátka:</span>
                      <span className="pp-v">{eur(Math.max(0, Number(splatka) || 0))} €</span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">Splátka + stress test:</span>
                      <span className={`pp-v ${jePrekrocenaMaxSplatkaDsti ? 'pp-v--error' : ''}`}>
                        {eur(Math.max(0, Number(stresssplatka) || 0))} €
                      </span>
                    </div>
    
                    <h3 className="subhead mt">Limity - DTI/DSTI:</h3>
                    <div className="parametre-divider" />
    
                    <div className="pp-riadok">
                      <span className="pp-k">Maximálna výška úveru:</span>
                      <span className="pp-v">
                        {eur(
                          Math.round(
                            Math.min(
                              Math.max(0, Number(dtiVysledok) || 0),
                              Math.max(0, Number(stressdti) || 0)
                            )
                          )
                        )}{" "}
                        €
                      </span>
                    </div>
    
                    <div className="pp-riadok sub">
                      <span className="pp-k">DTI</span>
                      <span className="pp-v pp-v--normal">{eur(Math.max(0, Number(dtiVysledok) || 0))} €</span>
                    </div>
    
                    <div className="pp-riadok sub">
                      <span className="pp-k">Stress DTI</span>
                      <span className="pp-v pp-v--normal">{eur(Math.max(0, Number(stressdti) || 0))} €</span>
                    </div>
    
                    <div className="pp-riadok">
                      <span className="pp-k">Maximálna splátka (DSTI):</span>
                      <span className="pp-v">{eur(Math.max(0, Number(dstistresssplatka) || 0))} €</span>
                    </div>
    
                    <div className="pp-riadok sub">
                      <span className="pp-k">Rozdiel (dispo na splátku)</span>
                      <span className="pp-v pp-v--normal">
                        {eur(Math.round((Number(dstistresssplatka) || 0) - (Number(stresssplatka) || 0)))} €
                      </span>
                    </div>
    
                    <div className={`fincloud-tip-slot ${maFincloudTip ? "" : "fincloud-tip-slot--hidden"}`}>
                      <>
                        <h3 className="subhead mt fincloud-tip-head">
                          <span className="fincloud-tip-bulb" aria-hidden="true">💡</span>
                          FinCloud Tip:
                        </h3>
                        <div className="parametre-divider" />
    
                        <div className="fincloud-insights">
                         {(maFincloudTip ? fincloudTip.tipy : fincloudTipPlaceholder).map((t) => (
                          <div key={t.faza} className={`pp-riadok pp-riadok--full fincloud-insight ${maFincloudTip ? "" : "is-placeholder"}`}>
                            <span className="pp-k">
                              {fincloudTip?.sablona?.pred || ""}
                              <strong>{maFincloudTip ? `${eur(t.mesacne)} €` : "0 €"}</strong>
                              {fincloudTip?.sablona?.pred2 || ""}
                              <br />
                              {fincloudTip?.sablona?.stred || ""}
                              <br />
                              {fincloudTip?.sablona?.za || ""}
                              <strong>{maFincloudTip ? t.usetreneRoky : "0"}</strong>
                              {fincloudTip?.sablona?.za2 || ""}
                            </span>
                            <span className="pp-v pp-v--normal"></span>
                          </div>
                        ))}
                        </div>
                        <div className="fincloud-tip-poznamka">
                          Pri priemernom ročnom zhodnotení 6%.
                        </div>
                      </>
                    
                    </div>
    
                  </div>
                </div>
    
                <div className="parametre-divider" />
                <ActionRow onReset={resetujAplikaciu} onUlozPdf={ulozPonukuPdf} />
              </div>
  );
}